import React from 'react';
import { Download, RefreshCw, Trash2 } from 'lucide-react';
import authService from '../../../services/authService';

const ImportButton = ({ 
  isQbConnected, 
  userProfile, 
  importing, 
  isSSEImporting, 
  sseProgress, 
  importProgress, 
  totalInvoices,
  onImport, 
  onDeleteAll 
}) => {
  // Show delete button for admins even if QB not connected
  const showDeleteButton = authService.hasAdminReturn() && userProfile?.role !== 'admin' && totalInvoices > 0;
  const isAdminSession = userProfile?.role === 'admin' || authService.hasAdminReturn();
  const showImportButton = isQbConnected && isAdminSession;

  // If neither button should show, return null
  if (!showImportButton && !showDeleteButton) {
    return null;
  }

  return (
    <div className="flex space-x-3">
      {/* Import Button - Only show when QB connected and proper role */}
      {showImportButton && (
        <button
          onClick={onImport}
          disabled={importing || isSSEImporting}
          className="btn btn-md btn-secondary"
        >
          <img src="/quickbooks-logo.svg" alt="QuickBooks" className="w-4 h-4" />
          {(importing || isSSEImporting) ? (
            <RefreshCw size={16} className="animate-spin" />
          ) : (
            <Download size={16} />
          )}
          <span>
            {(importing || isSSEImporting) ? (
              sseProgress.total > 0 || importProgress.total > 0 ? 
                `Importing ${sseProgress.total > 0 ? sseProgress.current : importProgress.current}/${sseProgress.total > 0 ? sseProgress.total : importProgress.total} - ${Math.round(sseProgress.total > 0 ? (sseProgress.current / sseProgress.total) * 100 : (importProgress.current / importProgress.total) * 100)}% complete` :
                'Importing from QuickBooks...'
            ) : (
              'Import from QuickBooks'
            )}
          </span>
        </button>
      )}
      
      {/* Admin-only Delete All Invoices Button - Show for admins even without QB connection */}
      {showDeleteButton && (
        <button
          onClick={onDeleteAll}
          className="btn btn-md btn-danger"
          title="Admin only: Delete all invoices (for testing)"
        >
          <Trash2 size={16} />
          <span>Delete All ({totalInvoices})</span>
        </button>
      )}
    </div>
  );
};

export default ImportButton;